module.exports = __webpack_public_path__ + "img/t3-petition.b6c91c73.png";